import { TCategory } from '@api/io/categories.io';
import { MappedCategoryData } from '@hooks/useFilterCategoryData';

type Props = {
  categoryData?: MappedCategoryData | null;
};

type ReturnType = { label: string; href: string }[];
export const useCategoryBreadcrumbs = ({ categoryData }: Props): ReturnType => {
  const { selectedCategory, flatCategories } = categoryData || {};
  if (!selectedCategory) {
    return [];
  }

  let breadcrumbs: ReturnType = [];
  let currentCategory: TCategory | undefined = selectedCategory;
  while (currentCategory) {
    breadcrumbs = [
      {
        label: currentCategory.name,
        href: `/?categories=${currentCategory.id}`,
      },
      ...breadcrumbs,
    ];
    currentCategory = flatCategories?.get(currentCategory.parentId || -1);
  }

  return breadcrumbs;
};
